export type StepperType = 'horizontal' | 'vertical';

export type StepperStyle = 'small' | 'large';
// small - stepper style with small icons (pim - onboarding form)
// large - stepper style with large numbers (pim - product form)
